(function () {
    'use strict';

    // ─── Kritische Browser-APIs sofort sichern ──────────────────────────────
    // Muss als ERSTES passieren — noch bevor irgendein anderes Script
    // (Themes, Plugins, Polyfills) diese Referenzen verändern kann.
    // OnFinds arbeitet danach ausschließlich mit diesen gesicherten Kopien.
    var _doc                 = document;
    var _win                 = window;
    var _head                = _doc.head || _doc.getElementsByTagName('head')[0];
    var _createElement       = _doc.createElement.bind(_doc);
    var _appendChild         = _head.appendChild.bind(_head);
    var _querySelectorAll    = _doc.querySelectorAll.bind(_doc);
    var _getElementsByTagName= _doc.getElementsByTagName.bind(_doc);
    var _docAddEvent         = _doc.addEventListener.bind(_doc);
    var _setTimeout          = _win.setTimeout.bind(_win);
    var _fetch               = (typeof _win.fetch === 'function') ? _win.fetch.bind(_win) : null;
    var NativePromise        = _win.Promise;
    var NativeWeakSet        = _win.WeakSet;
    var NativeMutationObserver = _win.MutationObserver;
    // ────────────────────────────────────────────────────────────────────────

    function stripWww(host) {
        return host.indexOf('www.') === 0 ? host.slice(4) : host;
    }

    function normalizeSettingsHost() {
        var settings = _win.onfinds_settings;
        if (!settings) {
            return;
        }
        var currentHost = _win.location.host.toLowerCase();
        var keys = ['shop_url', 'base_url'];
        for (var i = 0; i < keys.length; i++) {
            var value = settings[keys[i]];
            if (typeof value !== 'string' || value === '') {
                continue;
            }
            var match = /^https?:\/\/([^\/]+)/i.exec(value);
            if (!match) {
                continue;
            }
            var configuredHost = match[1].toLowerCase();
            if (configuredHost === currentHost) {
                continue;
            }
            if (stripWww(configuredHost) !== stripWww(currentHost)) {
                continue;
            }
            settings[keys[i]] = _win.location.origin + value.slice(match[0].length);
        }
    }

    normalizeSettingsHost();

    function logLoadError(name) {
        return function (err) {
            if (_win.console && typeof _win.console.error === 'function') {
                _win.console.error('[OnFinds] Ladefehler: ' + name, err);
            }
        };
    }

    // ─── Kaltstart-Skeleton ──────────────────────────────────────────────────
    // Rein visuelle Platzhalter-Hülle, die beim ersten Fokus/Touch sofort
    // erscheint, während Bundle + Core noch laden. pointer-events:none —
    // blockiert nichts. Nur im Overlay-Theme ('full-search'), da discovery
    // (Instant-Dropdown) und integrated (Inline-Layout) eigene Öffnungswege haben.
    var _skeletonEl = null;
    var _skeletonObserver = null;
    var _skeletonTimer = null;

    function skeletonApplies() {
        var theme = (_win.onfinds_settings && _win.onfinds_settings.onf_design_template) || 'full-search';
        return theme === 'full-search';
    }

    function removeSkeleton() {
        try {
            if (_skeletonTimer) { _win.clearTimeout(_skeletonTimer); _skeletonTimer = null; }
            if (_skeletonObserver) { _skeletonObserver.disconnect(); _skeletonObserver = null; }
            if (_skeletonEl && _skeletonEl.parentNode) { _skeletonEl.parentNode.removeChild(_skeletonEl); }
            _skeletonEl = null;
        } catch (e) {}
    }

    function showSkeleton(searchInput) {
        try {
            if (_skeletonEl || !skeletonApplies()) return;
            var overlay = _doc.getElementById('onf-search-results');
            if (overlay && overlay.classList.contains('onf-visible')) return;

            if (!_doc.getElementById('onf-skeleton-style')) {
                var style = _createElement('style');
                style.id = 'onf-skeleton-style';
                style.textContent = '@keyframes onfSkelShimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}' +
                    '.onf-skeleton-block{border-radius:6px;background:linear-gradient(90deg,rgba(127,127,127,0.16) 25%,rgba(127,127,127,0.07) 50%,rgba(127,127,127,0.16) 75%);background-size:800px 100%;animation:onfSkelShimmer 1.1s linear infinite}';
                _appendChild(style);
            }

            var top = 60;
            try {
                var rect = searchInput.getBoundingClientRect();
                if (rect && rect.bottom > 0 && rect.bottom < _win.innerHeight) {
                    top = Math.max(60, Math.round(rect.bottom + 8));
                }
            } catch (e) {}

            var el = _createElement('div');
            el.id = 'onf-loader-skeleton';
            el.style.cssText = 'position:fixed;top:' + top + 'px;left:50%;transform:translateX(-50%);' +
                'width:90%;max-width:1550px;bottom:1vh;z-index:99998;background:var(--onf-overlay-bg,#fff);border-radius:6px;' +
                'box-shadow:0 4px 20px rgba(0,0,0,.15);pointer-events:none;overflow:hidden;padding:22px;';

            var headerBar = _createElement('div');
            headerBar.className = 'onf-skeleton-block';
            headerBar.style.cssText = 'height:26px;width:38%;max-width:320px;';
            el.appendChild(headerBar);

            var grid = _createElement('div');
            grid.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(190px,1fr));gap:16px;margin-top:22px;';
            for (var i = 0; i < 10; i++) {
                var card = _createElement('div');
                card.className = 'onf-skeleton-block';
                card.style.cssText = 'height:240px;';
                grid.appendChild(card);
            }
            el.appendChild(grid);

            (_doc.body || _head).appendChild(el);
            _skeletonEl = el;

            if (typeof NativeMutationObserver === 'function' && _doc.body) {
                _skeletonObserver = new NativeMutationObserver(function () {
                    var ov = _doc.getElementById('onf-search-results');
                    if (ov && ov.classList.contains('onf-visible')) {
                        removeSkeleton();
                    }
                });
                _skeletonObserver.observe(_doc.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
            }
            _skeletonTimer = _setTimeout(removeSkeleton, 4000);
        } catch (e) {
            logLoadError('skeleton')(e);
        }
    }

    class OnFindsSearchLoader {
        constructor(searchInput) {
            this.searchInput = searchInput;
            this.coreLoaded = false;
            this.coreLoading = false;
            this.coreLoadingPromise = null;
            this.preloading = false;
            this.assetsPrefetched = false;

            // Globales Script-Tracking: verhindert Doppel-Laden über mehrere Loader-Instanzen
            if (!_win._salepix_loaded_scripts) _win._salepix_loaded_scripts = {};
            if (!_win._salepix_loading_scripts) _win._salepix_loading_scripts = {};

            this.loadedScripts = _win._salepix_loaded_scripts;
            this.loadingScripts = _win._salepix_loading_scripts;
            this.modules = {};
            this.baseUrl = this.getBaseUrl();
            this.version = this.getVersion();
            this.pendingAction = null;
            this.actionPending = false;
        }

        getVersion() {
            return (_win.onfinds_settings && _win.onfinds_settings.version) || '';
        }

        getBaseUrl() {
            if (_win.onfinds_settings && _win.onfinds_settings.base_url) {
                return _win.onfinds_settings.base_url;
            }
            try {
                const scripts = _getElementsByTagName('script');
                for (let i = 0; i < scripts.length; i++) {
                    const src = scripts[i].src;
                    if (src && src.includes('loader.js')) {
                        return src.substring(0, src.lastIndexOf('/'));
                    }
                }
            } catch (e) {}
            return '';
        }

        init() {
            try {
                this.searchInput.addEventListener('mouseenter', () => {
                    try { this.loadCore('hover'); } catch (e) {}
                }, { once: true });

                const handleInteraction = async () => {
                    if (!this.coreLoaded && !this.actionPending) {
                        this.actionPending = true;
                        this.pendingAction = () => {
                            try {
                                this.searchInput.focus();
                                if (this.searchInput.value) {
                                    const inputEvent = new Event('input', { bubbles: true });
                                    this.searchInput.dispatchEvent(inputEvent);
                                }
                            } catch (e) {}
                        };
                        try {
                            await this.loadCore('interaction');
                        } catch (e) {
                            removeSkeleton();
                        }
                        const action = this.pendingAction;
                        this.pendingAction = null;
                        this.actionPending = false;
                        if (typeof action === 'function') {
                            action();
                        }
                    }
                };

                this.searchInput.addEventListener('focus', handleInteraction, { once: false });
                this.searchInput.addEventListener('click', () => {
                    if (!this.coreLoaded) {
                        showSkeleton(this.searchInput);
                    }
                    handleInteraction();
                }, { once: false });
                this.searchInput.addEventListener('touchstart', async () => {
                    if (!this.coreLoaded && !this.actionPending) {
                        this.actionPending = true;
                        showSkeleton(this.searchInput);
                        this.pendingAction = () => {
                            try { this.searchInput.focus(); } catch (e) {}
                        };
                        try { await this.loadCore('interaction'); } catch (e) {
                            removeSkeleton();
                        }
                        const action = this.pendingAction;
                        this.pendingAction = null;
                        this.actionPending = false;
                        if (typeof action === 'function') {
                            action();
                        }
                    }
                }, { once: false, passive: true });
            } catch (e) {}
        }

        activateCSS() {
            try {
                const preloadLink = _doc.getElementById('salepix-search-css-preload');
                if (preloadLink && (preloadLink.rel === 'preload' || preloadLink.getAttribute('as'))) {
                    preloadLink.rel = 'stylesheet';
                    preloadLink.removeAttribute('as');
                    preloadLink.media = 'all';
                }
            } catch (e) {}
        }

        async preloadCore() {
            if (this.coreLoaded || this.preloading) return;
            this.preloading = true;
            this.activateCSS();
            try {
                const link = _createElement('link');
                link.rel = 'preload';
                link.as = 'script';
                link.href = this.baseUrl + '/core.js' + (this.version ? '?v=' + this.version : '');
                _appendChild(link);
            } catch (e) {}
        }

        prefetchAssets() {
            if (this.coreLoaded || this.coreLoading || this.assetsPrefetched) return;
            this.assetsPrefetched = true;
            try {
                const vParam = this.version ? '?v=' + this.version : '';
                const target = this.useBundle() ? '/search-bundle.js' : '/core.js';
                const link = _createElement('link');
                link.rel = 'prefetch';
                link.as = 'script';
                link.href = this.baseUrl + target + vParam;
                _appendChild(link);

                const langUrl = _win.onfinds_settings && _win.onfinds_settings.lang_url;
                if (langUrl && !_win.onfinds_lang) {
                    const langLink = _createElement('link');
                    langLink.rel = 'prefetch';
                    langLink.href = langUrl;
                    _appendChild(langLink);
                }
            } catch (e) {
                logLoadError('prefetch')(e);
            }
        }

        useBundle() {
            return this.baseUrl.indexOf('/dist/') !== -1;
        }

        loadLang() {
            const langUrl = _win.onfinds_settings && _win.onfinds_settings.lang_url;
            return (langUrl && _fetch && !_win.onfinds_lang)
                ? _fetch(langUrl)
                    .then(function (r) { return r.ok ? r.json() : null; })
                    .then(function (data) { if (data) _win.onfinds_lang = data; })
                    .catch(logLoadError('lang'))
                : NativePromise.resolve();
        }

        async loadCore(intent = 'interaction') {
            if (this.coreLoaded) return;
            if (intent) _win._onfinds_load_intent = intent;
            if (this.coreLoading && this.coreLoadingPromise) return this.coreLoadingPromise;

            // Prod: ein einziges Bundle (search-bundle.js) statt 30 Dateien in 5 seriellen Wellen.
            if (this.useBundle()) {
                this.coreLoading = true;
                this.coreLoadingPromise = (async () => {
                    try {
                        this.activateCSS();
                        await NativePromise.all([
                            this.loadLang(),
                            this.loadScript('search-bundle.js')
                        ]);
                        this.coreLoaded = true;
                    } catch (error) {
                        logLoadError('search-bundle.js')(error);
                        throw error;
                    } finally {
                        this.coreLoading = false;
                        this.coreLoadingPromise = null;
                    }
                })();
                return this.coreLoadingPromise;
            }

            const wasLoading = this.coreLoading;
            this.coreLoading = true;
            this.coreLoadingPromise = (async () => {
                try {
                    if (!wasLoading) {
                        await this.preloadCore();
                    }

                    // Phase 1: Core Utilities + Lang-Datei (parallel)
                    // Jedes Script hat .catch(logLoadError(...)) — ein Ladefehler bricht
                    // nicht alles ab, wird aber als console.error sichtbar gemacht.
                    // _fetch (gesicherte Referenz) statt window.fetch → immun gegen Polyfill-Fehler.
                    const langUrl = _win.onfinds_settings && _win.onfinds_settings.lang_url;
                    const langPromise = (langUrl && _fetch && !_win.onfinds_lang)
                        ? _fetch(langUrl)
                            .then(function (r) { return r.ok ? r.json() : null; })
                            .then(function (data) { if (data) _win.onfinds_lang = data; })
                            .catch(logLoadError('lang'))
                        : NativePromise.resolve();

                    await NativePromise.all([
                        langPromise,
                        this.loadScript('bridge.js').catch(logLoadError('bridge.js')),
                        this.loadScript('constants.js').catch(logLoadError('constants.js')),
                        this.loadScript('utils/safe-storage.js').catch(logLoadError('utils/safe-storage.js')),
                        this.loadScript('utils/config-manager.js').catch(logLoadError('utils/config-manager.js')),
                        this.loadScript('utils/z-index-elevator.js').catch(logLoadError('utils/z-index-elevator.js'))
                    ]);

                    // Phase 2a: Shared Components (ProductCard + SearchVariants — VOR template-engine)
                    await NativePromise.all([
                        this.loadScript('modules/product-card.js').catch(logLoadError('modules/product-card.js')),
                        this.loadScript('modules/search-variants.js').catch(logLoadError('modules/search-variants.js'))
                    ]);

                    // Phase 2b: Functional Modules and Managers
                    await NativePromise.all([
                        this.loadScript('state/cache-manager.js').catch(logLoadError('state/cache-manager.js')),
                        this.loadScript('state/state-manager.js').catch(logLoadError('state/state-manager.js')),
                        this.loadScript('handlers/shipping-link-handler.js').catch(logLoadError('handlers/shipping-link-handler.js')),
                        this.loadScript('modules/template-engine.js').catch(logLoadError('modules/template-engine.js')),
                        this.loadScript('modules/tab-controller.js').catch(logLoadError('modules/tab-controller.js')),
                        this.loadScript('modules/facet-handler.js').catch(logLoadError('modules/facet-handler.js')),
                        this.loadScript('modules/price-slider-controller.js').catch(logLoadError('modules/price-slider-controller.js')),
                        this.loadScript('modules/dimension-slider-controller.js').catch(logLoadError('modules/dimension-slider-controller.js')),
                        this.loadScript('modules/renderer-client.js').catch(logLoadError('modules/renderer-client.js')),
                        this.loadScript('modules/search-api-client.js').catch(logLoadError('modules/search-api-client.js')),
                        this.loadScript('modules/voice-search.js').catch(logLoadError('modules/voice-search.js')),
                        this.loadScript('modules/url-state-manager.js').catch(logLoadError('modules/url-state-manager.js')),
                        this.loadScript('modules/instant-dropdown.js').catch(logLoadError('modules/instant-dropdown.js')),
                        this.loadScript('modules/ai-assistant.js').catch(logLoadError('modules/ai-assistant.js')),
                        this.loadScript('modules/onfinds-cart-handler.js').catch(logLoadError('modules/onfinds-cart-handler.js')),
                        this.loadScript('modules/compare-state.js').catch(logLoadError('modules/compare-state.js')),
                        this.loadScript('modules/compare-toggle.js').catch(logLoadError('modules/compare-toggle.js')),
                        this.loadScript('modules/compare-pill.js').catch(logLoadError('modules/compare-pill.js')),
                        this.loadScript('modules/compare-modal.js').catch(logLoadError('modules/compare-modal.js')),
                        this.loadScript('modules/compare-page.js').catch(logLoadError('modules/compare-page.js')),
                        this.loadScript('modules/ga4-tracker.js').catch(logLoadError('modules/ga4-tracker.js'))
                    ]);

                    // Phase 3: Final Core Logic
                    // core.js setzt window.onfindsCore — erst danach können
                    // filter-Module geladen werden, da sie window.onfindsCore benötigen.
                    await this.loadScript('core.js');

                    // Phase 3b: Filter-Module (benötigen window.onfindsCore aus core.js)
                    await NativePromise.all([
                        this.loadScript('modules/filters-desktop.js').catch(logLoadError('modules/filters-desktop.js')),
                        this.loadScript('modules/filters-mobile.js').catch(logLoadError('modules/filters-mobile.js'))
                    ]);

                    this.coreLoaded = true;
                } catch (error) {
                    logLoadError('core.js')(error);
                    throw error;
                } finally {
                    this.coreLoading = false;
                    this.coreLoadingPromise = null;
                }
            })();
            return this.coreLoadingPromise;
        }

        async loadModule(name) {
            if (this.modules[name]) return;
            if (_win._onfinds_bundled) {
                this.modules[name] = true;
                return;
            }
            try {
                await this.loadScript('modules/' + name + '.js');
                this.modules[name] = true;
            } catch (e) {
                logLoadError('modules/' + name + '.js')(e);
            }
        }

        // loadScript mit 1 automatischem Retry nach 800ms
        // Verwendet gesicherte _createElement / _appendChild → immun gegen Monkey-Patching.
        loadScript(src) {
            if (this.loadedScripts[src]) return NativePromise.resolve();
            if (this.loadingScripts[src]) return this.loadingScripts[src];

            const scriptSrc = this.baseUrl + '/' + src + (this.version ? '?v=' + this.version : '');
            const loadedScripts  = this.loadedScripts;
            const loadingScripts = this.loadingScripts;

            this.loadingScripts[src] = new NativePromise(function (resolve, reject) {
                var attempt = function (attemptsLeft) {
                    try {
                        var script = _createElement('script');
                        script.src = scriptSrc;
                        script.async = true;
                        script.onload = function () {
                            loadedScripts[src] = true;
                            delete loadingScripts[src];
                            resolve();
                        };
                        script.onerror = function () {
                            if (attemptsLeft > 0) {
                                _setTimeout(function () { attempt(attemptsLeft - 1); }, 800);
                            } else {
                                delete loadingScripts[src];
                                reject(new Error('Failed to load: ' + src));
                            }
                        };
                        _appendChild(script);
                    } catch (e) {
                        if (attemptsLeft > 0) {
                            _setTimeout(function () { attempt(attemptsLeft - 1); }, 800);
                        } else {
                            delete loadingScripts[src];
                            reject(e);
                        }
                    }
                };
                attempt(1); // 1 Retry
            });
            return this.loadingScripts[src];
        }
    }

    _win.OnFindsSearchLoader = OnFindsSearchLoader;

    function restoreSearchQuery(searchInput) {
        try {
            const urlParams = new URLSearchParams(_win.location.search);
            const urlQuery = urlParams.get('onf');
            if (urlQuery && searchInput && !searchInput.value.trim()) {
                searchInput.value = urlQuery;
                return urlQuery;
            }
        } catch (e) {}

        try {
            const savedQuery = _win.SafeStorage
                ? _win.SafeStorage.get('onfinds_query', '')
                : '';
            if (savedQuery && searchInput && !searchInput.value.trim()) {
                searchInput.value = savedQuery;
            }
            return savedQuery || '';
        } catch (e) { return ''; }
    }

    function getSearchInputs() {
        try {
            if (!_win.onfinds_settings) return [];
            const searchInputs = [];
            const selectors = [
                _win.onfinds_settings.search_selector,
                _win.onfinds_settings.search_selector_2
            ];
            for (const selector of selectors) {
                if (!selector || typeof selector !== 'string' || selector.trim().length === 0) continue;
                const trimmedSelector = selector.trim();
                try {
                    const allMatches = _querySelectorAll(trimmedSelector);
                    for (let i = 0; i < allMatches.length; i++) {
                        const element = allMatches[i];
                        if (element.tagName === 'INPUT') {
                            searchInputs.push(element);
                        }
                    }
                } catch (e) {} // ungültiger CSS-Selector → ignorieren
            }
            return searchInputs;
        } catch (e) { return []; }
    }

    const initializedInputs = new NativeWeakSet();

    function initializeSearchInput(searchInput) {
        try {
            if (!searchInput || searchInput.tagName !== 'INPUT' || initializedInputs.has(searchInput)) return;
            initializedInputs.add(searchInput);
            restoreSearchQuery(searchInput);
            if (_win.salepixVoiceSearch && typeof _win.salepixVoiceSearch.registerInput === 'function') {
                try { _win.salepixVoiceSearch.registerInput(searchInput, { context: 'native' }); } catch (e) {}
            }
            const loader = new OnFindsSearchLoader(searchInput);
            loader.init();
            if (!_win._onfinds_first_loader) {
                _win._onfinds_first_loader = loader;
            }
        } catch (e) {}
    }

    function initExistingInputs() {
        try {
            const searchInputs = getSearchInputs();
            if (searchInputs.length === 0) return;
            searchInputs.forEach(initializeSearchInput);
        } catch (e) {}
    }

    function observeDynamicInputs() {
        try {
            if (!_win.onfinds_settings || typeof NativeMutationObserver === 'undefined') return;
            const selectors = [
                _win.onfinds_settings.search_selector,
                _win.onfinds_settings.search_selector_2
            ].filter(function (s) { return typeof s === 'string' && s.trim().length > 0; })
                .map(function (s) { return s.trim(); });
            if (selectors.length === 0) return;

            const observer = new NativeMutationObserver(function (mutations) {
                try {
                    for (const mutation of mutations) {
                        if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
                        mutation.addedNodes.forEach(function (node) {
                            try {
                                if (!node || node.nodeType !== 1) return;
                                selectors.forEach(function (selector) {
                                    try {
                                        if (typeof node.matches === 'function' && node.matches(selector) && node.tagName === 'INPUT') {
                                            initializeSearchInput(node);
                                        }
                                        const descendants = node.querySelectorAll(selector);
                                        descendants.forEach(function (element) {
                                            if (element.tagName === 'INPUT') initializeSearchInput(element);
                                        });
                                    } catch (e) {}
                                });
                            } catch (e) {}
                        });
                    }
                } catch (e) {}
            });
            observer.observe(_doc.body, { childList: true, subtree: true });
        } catch (e) {}
    }

    function hasUrlSearchParams() {
        try {
            const params = new URLSearchParams(_win.location.search);
            return params.has('onf') || params.has('f') || params.has('sort') ||
                params.has('price_min') || params.has('price_max') ||
                params.has('tab') || params.has('view') || params.has('page');
        } catch (e) { return false; }
    }

    // Idle-Warmup gemäß Einstellung js_load_strategy:
    //   'idle_prefetch' (Default) — Bundle + Sprachdatei nach dem load-Event mit
    //       niedriger Priorität in den HTTP-Cache holen (keine Ausführung, keine
    //       Auswirkung auf Core Web Vitals)
    //   'idle_execute' — zusätzlich Core im Leerlauf komplett initialisieren
    //   'interaction'  — bisheriges Verhalten, kein Warmup
    // Bei aktivem Datensparmodus (navigator.connection.saveData) wird nie vorgeladen.
    function scheduleIdleWarmup(loader) {
        try {
            if (!loader) return;
            var strategy = (_win.onfinds_settings && _win.onfinds_settings.js_load_strategy) || 'idle_prefetch';
            if (strategy === 'interaction') return;
            var conn = _win.navigator && _win.navigator.connection;
            if (conn && conn.saveData === true) return;

            var run = function () {
                if (loader.coreLoaded || loader.coreLoading) return;
                if (strategy === 'idle_execute') {
                    loader.loadCore('idle').catch(logLoadError('idle-warmup'));
                } else {
                    loader.prefetchAssets();
                }
            };
            var scheduleAfterLoad = function () {
                _setTimeout(function () {
                    if (typeof _win.requestIdleCallback === 'function') {
                        _win.requestIdleCallback(run, { timeout: 4000 });
                    } else {
                        run();
                    }
                }, 1500);
            };
            if (_doc.readyState === 'complete') {
                scheduleAfterLoad();
            } else {
                _win.addEventListener('load', scheduleAfterLoad, { once: true });
            }
        } catch (e) {
            logLoadError('idle-warmup')(e);
        }
    }

    var _fabOptionEnabled = function (value) {
        return value === 'enabled' || value === true || value === '1';
    };

    function openAssistantFromFab() {
        var afterCore = function () {
            try {
                if (_win.onfindsCore && typeof _win.onfindsCore.showResults === 'function') {
                    NativePromise.resolve(_win.onfindsCore.showResults()).then(function () {
                        if (_win.OnFindsAiAssistant && typeof _win.OnFindsAiAssistant.open === 'function') {
                            _win.OnFindsAiAssistant.open();
                        }
                    }).catch(logLoadError('assistant-fab-open'));
                } else if (_win.OnFindsAiAssistant && typeof _win.OnFindsAiAssistant.open === 'function') {
                    _win.OnFindsAiAssistant.open();
                }
            } catch (e) { logLoadError('assistant-fab-open')(e); }
        };
        try {
            var loader = _win._onfinds_first_loader;
            if (!loader && typeof OnFindsSearchLoader === 'function') {
                loader = new OnFindsSearchLoader(_doc.body);
                _win._onfinds_first_loader = loader;
            }
            if (loader && typeof loader.loadCore === 'function') {
                loader.loadCore('interaction').then(afterCore).catch(function (e) {
                    logLoadError('assistant-fab-core')(e);
                    afterCore();
                });
            } else {
                afterCore();
            }
        } catch (e) { logLoadError('assistant-fab')(e); afterCore(); }
    }

    function watchOverlayForFab(fab) {
        var apply = function () {
            try {
                var ov = _doc.getElementById('onf-search-results');
                var open = !!(ov && (ov.classList.contains('onf-visible') || ov.classList.contains('onf-ai-active')));
                fab.style.display = open ? 'none' : '';
            } catch (e) { logLoadError('assistant-fab-watch')(e); }
        };
        apply();
        var attach = function () {
            var ov = _doc.getElementById('onf-search-results');
            if (!ov || !NativeMutationObserver) return !!ov;
            try {
                new NativeMutationObserver(apply).observe(ov, { attributes: true, attributeFilter: ['class'] });
            } catch (e) { logLoadError('assistant-fab-watch')(e); }
            apply();
            return true;
        };
        if (attach() || !NativeMutationObserver) return;
        try {
            var bodyObs = new NativeMutationObserver(function () {
                if (attach()) { bodyObs.disconnect(); }
            });
            bodyObs.observe(_doc.body, { childList: true });
        } catch (e) { logLoadError('assistant-fab-watch')(e); }
    }

    function mountAssistantFab() {
        try {
            var s = _win.onfinds_settings || {};
            if (!_fabOptionEnabled(s.assistant_enabled) || !_fabOptionEnabled(s.assistant_fab_enabled)) return;
            if (_doc.getElementById('onf-ai-fab')) return;
            if (!_doc.body) return;

            var pos = s.assistant_fab_position;
            if (pos !== 'left' && pos !== 'right') pos = 'center';

            var lang = _win.onfinds_lang || {};
            var label = (typeof lang.assistant_button === 'string' && lang.assistant_button) ? lang.assistant_button : 'KI-Assistent fragen';

            var fab = _createElement('button');
            fab.type = 'button';
            fab.id = 'onf-ai-fab';
            fab.className = 'onf-ai-fab onf-ai-fab--' + pos;
            fab.setAttribute('aria-haspopup', 'dialog');
            fab.setAttribute('aria-label', label);

            var icon = _createElement('span');
            icon.className = 'onf-ai-fab__icon';
            icon.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="none" aria-hidden="true"><path d="M11 3 9.4 7.4 5 9l4.4 1.6L11 15l1.6-4.4L17 9l-4.4-1.6L11 3z"/><path d="M18 2.5 17.3 4.3 15.5 5l1.8.7.7 1.8.7-1.8 1.8-.7-1.8-.7L18 2.5z"/><path d="M17 14.5l-.6 1.6-1.6.6 1.6.6.6 1.6.6-1.6 1.6-.6-1.6-.6-.6-1.6z"/></svg>';
            fab.appendChild(icon);

            var lbl = _createElement('span');
            lbl.className = 'onf-ai-fab__label';
            lbl.textContent = label;
            fab.appendChild(lbl);

            fab.addEventListener('click', function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                openAssistantFromFab();
            });

            _doc.body.appendChild(fab);
            watchOverlayForFab(fab);
        } catch (e) {}
    }

    // _bootstrapped verhindert Doppel-Ausführung (Timeout-Fallback vs. DOMContentLoaded)
    var _bootstrapped = false;

    function bootstrapLoader() {
        if (_bootstrapped) return;
        _bootstrapped = true;
        try {
            if (!_win.onfinds_settings) return;
            const urlHasSearchParams = hasUrlSearchParams();
            initExistingInputs();
            observeDynamicInputs();
            mountAssistantFab();
            if (urlHasSearchParams && _win._onfinds_first_loader) {
                _win._onfinds_first_loader.loadCore('url');
            }
            scheduleIdleWarmup(_win._onfinds_first_loader);
        } catch (e) {}
    }

    // Bootstrap mit gesicherter _docAddEvent-Referenz
    try {
        if (_doc.readyState === 'loading') {
            _docAddEvent('DOMContentLoaded', bootstrapLoader);
        } else {
            bootstrapLoader();
        }
    } catch (e) {
        // Fallback falls addEventListener selbst defekt ist
        _setTimeout(bootstrapLoader, 0);
    }

    // Absoluter Timeout-Fallback: greift wenn DOMContentLoaded nie feuert
    // (z.B. durch ein blockierendes Script oder einen Edge-Case im Browser).
    _setTimeout(bootstrapLoader, 3000);

})();
